export const ALLOWED_EXTENSIONS = ['.pdf', '.jpeg', '.jpg', '.png'];
